import { render, staticRenderFns } from "./McGeoughsInvoice.vue?vue&type=template&id=04feadfc&scoped=true&"
import script from "./McGeoughsInvoice.vue?vue&type=script&lang=js&"
export * from "./McGeoughsInvoice.vue?vue&type=script&lang=js&"
import style0 from "./McGeoughsInvoice.vue?vue&type=style&index=0&id=04feadfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04feadfc",
  null
  
)

export default component.exports